import { GOOGLE_TTS_API_KEY } from './constants';

// The stored copy of the signed-in reader, or null. `userDetails` is written
// by the Header on every visit — guests included — so its presence proves
// nothing on its own. `fullname` is only ever filled in for a real session,
// and is the same signal the Header uses to decide between the avatar and the
// sign-in button, so it is what "signed in" means here. Logout writes an empty
// string, which is why the parse is guarded.
export const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem('userDetails') || 'null');
  } catch (e) {
    return null;
  }
};

// `userDetails` from the store is hydrated asynchronously by the Header, so on
// a reload it is still null for a moment while the session is restored. The
// stored copy stands in until it lands; without it a signed-in reader is
// bounced off every protected page on every refresh.
export const isAuthenticated = (userDetails) => {
  return Boolean(userDetails?.fullname || getStoredUser()?.fullname);
};

export const getEncryptedValue = (_text = '') => {
  if (_text.length > 0) {
    const base64 = require('base-64');
    var utf8 = require('utf8');
    const bytes = utf8.encode(_text);
    return base64.encode(bytes);
  }
  return _text;
};

export const synthesizeSpeech = async (text, name = 'en-US-Wavenet-F') => {
  const API_KEY = GOOGLE_TTS_API_KEY;
  const url = `https://texttospeech.googleapis.com/v1/text:synthesize?key=${API_KEY}`;
  const body = {
    input: { text: text },
    voice: { languageCode: 'ar-XA', name: name },
    audioConfig: { audioEncoding: 'MP3' },
  };

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    const result = await response.json();
    return result; // contains audioContent (base64 MP3)
  } catch (error) {
    console.error('Error synthesizing speech:', error);
    throw error;
  }
};

export function stripTags(input) {
  if (!input) return '';
  return input.replace(/<\/?[^>]+(>|$)/g, '');
}
